import React from "react";
import { GuaranteeViewData } from "./GuaranteeDataModel";

type Props = { details: GuaranteeViewData; report?: boolean };

// Map a Nested risk level to the existing badge colours.
const riskColor = (level?: string) => {
  const l = (level ?? "").toLowerCase();
  if (l === "low" || l === "standard" || l === "acceptable") return "Green";
  if (l === "medium" || l === "elevated") return "Amber";
  if (l === "high" || l === "restricted" || l === "prohibited" || l === "critical")
    return "Red";
  return "Amber";
};

const statusColor = (status?: string) => {
  const s = (status ?? "").toLowerCase();
  if (s === "no_match" || s === "clear" || s === "clean") return "Green";
  if (s === "potential_match" || s === "match") return "Amber";
  return "Amber";
};

const decisionColor = (decision?: string) => {
  const d = (decision ?? "").toLowerCase();
  if (d === "approve" || d === "approved") return "Green";
  if (d === "reject" || d === "rejected") return "Red";
  return "Amber"; // manual_review / rfi_required / pending
};

// "potential_match" -> "Potential Match"
const humanize = (value?: string) =>
  !value ? value : value.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());

const GuaranteePanelRiskProfile: React.FC<Props> = ({ details, report = false }) => {
  const profile = details.riskProfile;
  if (!profile) {
    return null;
  }

  const score =
    profile.screeningScore != null ? Math.round(profile.screeningScore) : undefined;

  return (
    <div className={`ReportSummary ${report ? "increase-font" : ""}`}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {report ? (
          <h2 style={{ margin: 0 }}>Customer Risk Profile</h2>
        ) : (
          <h4 style={{ margin: 0 }}>Customer Risk Profile</h4>
        )}
        {score !== undefined && (
          <span className={`ColoredBox ${statusColor(profile.status)}`}>
            Screening Score: {score} / 100
          </span>
        )}
      </div>

      {profile.status && (
        <div>
          <span>Status</span>
          <span className={`ColoredBox ${statusColor(profile.status)}`}>
            {humanize(profile.status)}
          </span>
        </div>
      )}
      {profile.riskLevel && (
        <div>
          <span>Risk Level</span>
          <span className={`ColoredBox ${riskColor(profile.riskLevel)}`}>
            {profile.riskLevel}
          </span>
        </div>
      )}
      {profile.decision && (
        <div>
          <span>Decision</span>
          <span className={`ColoredBox ${decisionColor(profile.decision)}`}>
            {humanize(profile.decision)}
          </span>
        </div>
      )}
      {profile.decisionReason && (
        <div>
          <span>Reason</span>
          <span>{profile.decisionReason}</span>
        </div>
      )}
    </div>
  );
};

export default GuaranteePanelRiskProfile;
